import { render, staticRenderFns } from "./ApproveCredit.vue?vue&type=template&id=190ca83c&scoped=true&"
import script from "./ApproveCredit.vue?vue&type=script&lang=js&"
export * from "./ApproveCredit.vue?vue&type=script&lang=js&"
import style0 from "./ApproveCredit.vue?vue&type=style&index=0&id=190ca83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ca83c",
  null
  
)

export default component.exports